import { render } from "./ResetPasswordIcon.vue?vue&type=template&id=046bced0"
const script = {}

import "./ResetPasswordIcon.vue?vue&type=style&index=0&id=046bced0&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__